<div fxLayout="column" fxLayoutAlign="space-between">
  <div fxFlex>
    <h3>Would you like to delete all the codes that have been provisioned for future guests?</h3>
  </div>

  <div fxLayout fxLayoutAlign="start start" fxLayoutGap="12px">
    <mat-radio-group [(ngModel)]="deleteFutureCodes">
      <div fxLayout="column" fxLayoutGap="12px">
        <mat-radio-button [value]="false">No, keep existing codes</mat-radio-button>
        <mat-radio-button [value]="true">Yes, remove all codes</mat-radio-button>
      </div>
    </mat-radio-group>
  </div>

  <div fxLayoutAlign="end center" fxLayoutGap="8px" style="margin-top: 40px">
    <sbnb-button label="Save" (clicked)="save()"></sbnb-button>
  </div>
</div>
